export const trimKeys = (obj) => {
    return Object.keys(obj).reduce((acc, key) => {
        acc[key.trim()] = obj[key];
        return acc;
    }, {});
};

export function extractCityAndState(address) {
  const parts = address.split(',');
  if (parts.length >= 3) {
      const city = parts[1].trim();
      const state = parts[2].trim(); 
      return `${city}, ${state}`;
  } else {
      return ''; 
  }
}

export function extractCity(address) {
  const parts = address.split(',');
  //console.log(parts);
  if (parts.length >= 3) {
      const city = parts[1].trim();
      return city;
  } else {
      return ''; 
  }
}

export function sqftToFloorplanName(cid,sqft) {
    let res = 'Unknown';
    if(cid=='willfla1'){
        if (sqft >= 1025) {
            res = 'Gardenia+';
        } else if (sqft >= 550) {
            res = 'Morning Glory';
        } else if (sqft >= 547) {
            res = 'Gardenia';
        } else if (sqft >= 506) {
            res = 'The Bamboo';
        } else if (sqft >= 400) {
            res = 'Canary';
        } else if (sqft >= 360) {
            res = 'Aloe';
        } 
    }
    return res;
}

export function extractFloorplanInfo(data) {
    return data.map(item => ({
        floorplanName: item.node.floorplanName,
        sqFt: item.node.sqFt
    }));
}
    

export function reRentCafeLink(cid){
    //console.log('cid from rentCafeLink: ', cid);
    cid = cid.toLowerCase();
    let link;
    if (cid === 'amalfi') {
        link = 'https://amalfi-mckinley.securecafe.com/residentservices/amalfi1/userlogin.aspx';
    } else if (cid === 'aria-beach') {
        link = 'https://aria-beach-mckinley.securecafe.com/residentservices/aria-beach/userlogin.aspx';
    } else if (cid === 'aspen-chase') {
        link = 'https://aspen-chase-mckinley.securecafe.com/residentservices/aspen-chase2/userlogin.aspx';
    } else if (cid === 'azure') {
        link = 'https://azure-winter-park-mckinley.securecafe.com/residentservices/azure-winter-park0/userlogin.aspx';
    } else if (cid === 'bayshore-flats') {
        link = 'https://bayshore-flats-mckinley.securecafe.com/residentservices/bayshore-flats/userlogin.aspx';
    } else if (cid === 'beach-flats') {
        link = 'https://beach-flats-mckinley.securecafe.com/residentservices/beach-flats-0/userlogin.aspx';
    } else if (cid === 'bella-capri') {
        link = 'https://bella-capri-mckinley.securecafe.com/residentservices/bella-capri/userlogin.aspx';
    } else if (cid === 'bella-casa') {
        link = 'https://bella-casa-mckinley.securecafe.com/residentservices/bella-casa/userlogin.aspx';
    } else if (cid === 'bella-vita') {
        link = 'https://bella-vita-mckinley.securecafe.com/residentservices/bella-vita2/userlogin.aspx';
    } else if (cid === 'bellagio') {
        link = 'https://bellagio-mckinley.securecafe.com/residentservices/bellagio0/userlogin.aspx';
    } else if (cid === 'brooklyn-flats') {
        link = 'https://brooklyn-flats-mckinley.securecafe.com/residentservices/brooklyn-flats/userlogin.aspx';
    } else if (cid === 'carlyleflats' || cid === 'carlyle-flats') {
        link = 'https://carlyleflats-mckinley.securecafe.com/residentservices/carlyle-flats/userlogin.aspx';
    } else if (cid === 'celano') {
        link = 'https://celano-mckinley.securecafe.com/residentservices/celano/userlogin.aspx';
    } else if (cid === 'coconut-palms') {
        link = 'https://coconut-palms-mckinley.securecafe.com/residentservices/coconut-palms/userlogin.aspx';
    } else if (cid === 'conway-forest') {
        link = 'https://conway-forest-mckinley.securecafe.com/residentservices/conway-forest/userlogin.aspx';
    } else if (cid === 'eusonian') {
        link = 'https://eusonian-mckinley.securecafe.com/residentservices/eusonian/userlogin.aspx';
    } else if (cid === 'evergreen') {
        link = 'https://evergreen-mckinley.securecafe.com/residentservices/evergreen2/userlogin.aspx';
    } else if (cid === 'glencoe-hills') {
        link = 'https://glencoe-hills-mckinley.securecafe.com/residentservices/glencoe-hills1/userlogin.aspx';
    } else if (cid === 'glencoe-oaks') {
        link = 'https://glencoe-oaks-mckinley.securecafe.com/residentservices/glencoe-oaks0/userlogin.aspx';
    } else if (cid === 'golfside-lake' || cid === 'golfside') {
        link = 'https://golfside-lake-mckinley.securecafe.com/residentservices/golfside-lake/userlogin.aspx';
    } else if (cid === 'harbor-beach') {
        link = 'https://harbor-beach-mckinley.securecafe.com/residentservices/harbor-beach0/userlogin.aspx';
    } else if (cid === 'harper-flats') {
        link = 'https://harper-flats-mckinley.securecafe.com/residentservices/harper-flats/userlogin.aspx';
    } else if (cid === 'hillcrest-hillcrest' || cid === 'hillcrest') {
        link = 'https://hillcrest-hillcrest-mckinley.securecafe.com/residentservices/hillcrest8/userlogin.aspx';
    } else if (cid === 'hyde-park-flats') {
        link = 'https://hyde-park-flats-mckinley.securecafe.com/residentservices/hyde-park-flats/userlogin.aspx';
    } else if (cid === 'indigo-winter-park' || cid === 'indigo') {
        link = 'https://indigo-winter-park-mckinley.securecafe.com/residentservices/indigo-winter-park/userlogin.aspx';
    } else if (cid === 'iris-flats') {
        link = 'https://iris-flats-mckinley.securecafe.com/residentservices/iris-flats/userlogin.aspx';
    } else if (cid === 'ivy-flats') {
        link = 'https://ivy-flats-mckinley.securecafe.com/residentservices/ivy-flats/userlogin.aspx';
    } else if (cid === 'manchester-west') {
        link = 'https://manchester-west-mckinley.securecafe.com/residentservices/manchester-west/userlogin.aspx';
    } else if (cid === 'manchester-flats') {
        link = 'https://manchester-flats-mckinley.securecafe.com/residentservices/manchester-flats0/userlogin.aspx';
    } else if (cid === 'meadowbrook-village') {
        link = 'https://meadowbrook-village-mckinley.securecafe.com/residentservices/meadowbrook-village0/userlogin.aspx';
    } else if (cid === 'medical-court' || cid === 'medical-center-court') {
        link = 'https://medical-court-mckinley.securecafe.com/residentservices/medical-center-court0/userlogin.aspx';
    } else if (cid === 'monterey-lake') {
        link = 'https://monterey-lake-mckinley.securecafe.com/residentservices/monterey-lake/userlogin.aspx';
    } else if (cid === 'olivia-flats') {
        link = 'https://olivia-flats-mckinley.securecafe.com/residentservices/olivia-flats/userlogin.aspx';
    } else if (cid === 'mcdonald-mansion') {
        link = 'https://mcdonald-mansion-mckinley.securecafe.com/residentservices/mcdonald-mansion/userlogin.aspx';
    } else if (cid === 'palio') {
        link = 'https://palio-mckinley.securecafe.com/residentservices/palio/userlogin.aspx';
    } else if (cid === 'park-place') {
        link = 'https://park-place-mckinley.securecafe.com/residentservices/park-place22/userlogin.aspx';
    } else if (cid === 'parkland-flats') {
        link = 'https://parkland-flats-mckinley.securecafe.com/residentservices/parkland-flats/userlogin.aspx';
    } else if (cid === 'piccadilly' || cid === 'piccadilly-flats') {
        link = 'https://piccadilly-flats-mckinley.securecafe.com/residentservices/piccadilly-flats/userlogin.aspx';
    } else if (cid === 'portofino') {
        link = 'https://portofino-mckinley.securecafe.com/residentservices/portofino9/userlogin.aspx';
    } else if (cid === 'positano') {
        link = 'https://positano-mckinley.securecafe.com/residentservices/positano0/userlogin.aspx';
    } else if (cid === 'riva') {
        link = 'https://riva-mckinley.securecafe.com/residentservices/riva1/userlogin.aspx';
    } else if (cid === 'roundtree') {
        link = 'https://roundtree-roundtree-mckinley.securecafe.com/residentservices/roundtree/userlogin.aspx';
    } else if (cid === 'sapphire') {
        link = 'https://sapphire-winter-park-mckinley.securecafe.com/residentservices/sapphire-winter-park/userlogin.aspx';
    } else if (cid === 'schoolhouse' || cid === 'schoolhouse-flats') {
        link = 'https://schoolhouse-flats-mckinley.securecafe.com/residentservices/schoolhouse-flats/userlogin.aspx';
    } else if (cid === 'schooner-cove') {
        link = 'https://schooner-cove-mckinley.securecafe.com/residentservices/schooner-cove/userlogin.aspx';
    } else if (cid === 'serena') {
        link = 'https://serena-winter-park-mckinley.securecafe.com/residentservices/serena-winter-park/userlogin.aspx';
    } else if (cid === 'spruce-knob') {
        link = 'https://spruce-knob-mckinley.securecafe.com/residentservices/spruce-knob0/userlogin.aspx';
    } else if (cid === 'state-village' || cid === 'state-street-village') {
        link = 'https://state-village-mckinley.securecafe.com/residentservices/state-street-village/userlogin.aspx';
    } else if (cid === 'studio-parc' || cid === 'studioparc') {
        link = 'https://studio-parc-mckinley.securecafe.com/residentservices/studio-parc/userlogin.aspx';
    } else if (cid === 'the-frederick') {
        link = 'https://the-frederick-mckinley.securecafe.com/residentservices/the-frederick0/userlogin.aspx';
    } else if (cid === 'the-pines') {
        link = 'https://the-pines-mckinley.securecafe.com/residentservices/the-pines4/userlogin.aspx';
    } else if (cid === 'the-villas') {
        link = 'https://the-villas-mckinley.securecafe.com/residentservices/the-villas2/userlogin.aspx';
    } else if (cid === 'the-wesley') {
        link = 'https://the-wesley-mckinley.securecafe.com/residentservices/the-wesley1/userlogin.aspx';
    } else if (cid === 'traver-courts') {
        link = 'https://traver-courts-mckinley.securecafe.com/residentservices/traver-courts/userlogin.aspx';
    } else if (cid === 'traver-crossing') {
        link = 'https://traver-crossing-mckinley.securecafe.com/residentservices/traver-crossing/userlogin.aspx';
    } else if (cid === 'traver-ridge') {
        link = 'https://traver-ridge-mckinley.securecafe.com/residentservices/traver-ridge0/userlogin.aspx';
    } else if (cid === 'traver-heights') {
        link = 'https://traver-heights-mckinley.securecafe.com/residentservices/traver-ridge0/userlogin.aspx';
    } else if (cid === 'westshore-flats') {
        link = 'https://westshore-flats-i-mckinley.securecafe.com/residentservices/westshore-flats-i/userlogin.aspx';
    } else if (cid === 'westshore-flats-ii') {
        link = 'https://westshore-flats-ii-mckinley.securecafe.com/residentservices/westshore-flats-ii/userlogin.aspx';
    } else if (cid === 'westwood-suites') {
        link = 'https://westwood-suites-mckinley.securecafe.com/residentservices/westwood-suites/userlogin.aspx';
    } else if (cid === 'willow-flats') {
        link = 'https://willow-flats-mckinley.securecafe.com/residentservices/willow-flats/userlogin.aspx';
    } else {
        link = 'https://my.mckinley.com';
    }
    return link;
}

// getRentDisplay.js

export function getRentDisplay(node, priceRange, proformaRange, getYardiPropId) {

    const yardiPropId = getYardiPropId(node.rmpropid);

    let rentResults = calculateRentForCommunity(yardiPropId, priceRange, proformaRange, node.utilitiesIncluded);

    if (yardiPropId == 'sc1'){
        let rentResults2 = calculateRentForCommunity('sc2', priceRange, proformaRange, node.utilitiesIncluded);
        let rentResults3 = calculateRentForCommunity('sc3', priceRange, proformaRange, node.utilitiesIncluded);
        const avRents = [];
        if(rentResults.isFromAvailable){
            avRents.push(rentResults.displayLowRent);
        }
        if(rentResults2.isFromAvailable){
            avRents.push(rentResults2.displayLowRent);
        }
        if(rentResults3.isFromAvailable){
            avRents.push(rentResults3.displayLowRent);
        }
        //console.log(avRents);
        const lowestRent = avRents.length > 0 ? Math.min(...avRents) : Math.min(rentResults.displayLowRent,rentResults2.displayLowRent,rentResults3.displayLowRent);
        rentResults.displayLowRent = lowestRent;
        rentResults.displayHighRent = Math.max(rentResults.displayHighRent,rentResults2.displayHighRent,rentResults3.displayHighRent);
    }

    return `$${rentResults.displayLowRent} - $${rentResults.displayHighRent}${rentResults.utilitiesSuffix}`;
}

function calculateRentForCommunity(yardiPropId, priceRange, proformaRange, utilitiesIncluded) {
    // Proforma here is NOT the Proforma rent, but just the rent overall
    // We are only using market rent. 
    // Here Proform == Overall
    // Switching to displaying the highest overall rent instead of highest from availabile
    // highRent == highest from available (market)
    // proformaHighRent == highest overall (market)
    const lowRent = parseFloat(priceRange[yardiPropId]?.low_rent);
    const highRent = parseFloat(priceRange[yardiPropId]?.high_rent);
    const proformaLowRent = parseFloat(proformaRange[yardiPropId]?.plow_rent);
    const proformaHighRent = parseFloat(proformaRange[yardiPropId]?.phigh_rent);
    const utilitiesSuffix = utilitiesIncluded ? '*' : '';
    const displayLowRent = lowRent === 0 || lowRent === 42000 ? proformaLowRent || '000' : lowRent || '000';
    const displayHighRent = proformaHighRent === 0 ? highRent || '000' : proformaHighRent || '000';
    const isFromAvailable = displayLowRent != proformaHighRent;
    return { displayLowRent, displayHighRent, utilitiesSuffix, isFromAvailable };
}

export function reAllRentCafeLinks() {
    return {
        'amalfi': 'https://amalfi-mckinley.securecafe.com/residentservices/amalfi1/userlogin.aspx',
        'aria-beach': 'https://aria-beach-mckinley.securecafe.com/residentservices/aria-beach/userlogin.aspx',
        'aspen-chase': 'https://aspen-chase-mckinley.securecafe.com/residentservices/aspen-chase2/userlogin.aspx',
        'azure': 'https://azure-winter-park-mckinley.securecafe.com/residentservices/azure-winter-park0/userlogin.aspx',
        'bayshore-flats': 'https://bayshore-flats-mckinley.securecafe.com/residentservices/bayshore-flats/userlogin.aspx',
        'beach-flats': 'https://beach-flats-mckinley.securecafe.com/residentservices/beach-flats-0/userlogin.aspx',
        'bella-capri': 'https://bella-capri-mckinley.securecafe.com/residentservices/bella-capri/userlogin.aspx',
        'bella-casa': 'https://bella-casa-mckinley.securecafe.com/residentservices/bella-casa/userlogin.aspx',
        'bella-vita': 'https://bella-vita-mckinley.securecafe.com/residentservices/bella-vita2/userlogin.aspx',
        'bellagio': 'https://bellagio-mckinley.securecafe.com/residentservices/bellagio0/userlogin.aspx',
        'brooklyn-flats': 'https://brooklyn-flats-mckinley.securecafe.com/residentservices/brooklyn-flats/userlogin.aspx',
        'carlyleflats': 'https://carlyleflats-mckinley.securecafe.com/residentservices/carlyle-flats/userlogin.aspx',
        'carlyle-flats': 'https://carlyleflats-mckinley.securecafe.com/residentservices/carlyle-flats/userlogin.aspx',
        'celano': 'https://celano-mckinley.securecafe.com/residentservices/celano/userlogin.aspx',
        'coconut-palms': 'https://coconut-palms-mckinley.securecafe.com/residentservices/coconut-palms/userlogin.aspx',
        'conway-forest': 'https://conway-forest-mckinley.securecafe.com/residentservices/conway-forest/userlogin.aspx',
        'eusonian': 'https://eusonian-mckinley.securecafe.com/residentservices/eusonian/userlogin.aspx',
        'evergreen': 'https://evergreen-mckinley.securecafe.com/residentservices/evergreen2/userlogin.aspx',
        'glencoe-hills': 'https://glencoe-hills-mckinley.securecafe.com/residentservices/glencoe-hills1/userlogin.aspx',
        'glencoe-oaks': 'https://glencoe-oaks-mckinley.securecafe.com/residentservices/glencoe-oaks0/userlogin.aspx',
        'golfside-lake': 'https://golfside-lake-mckinley.securecafe.com/residentservices/golfside-lake/userlogin.aspx',
        'golfside': 'https://golfside-lake-mckinley.securecafe.com/residentservices/golfside-lake/userlogin.aspx',
        'harbor-beach': 'https://harbor-beach-mckinley.securecafe.com/residentservices/harbor-beach0/userlogin.aspx',
        'harper-flats': 'https://harper-flats-mckinley.securecafe.com/residentservices/harper-flats/userlogin.aspx',
        'hillcrest': 'https://hillcrest-hillcrest-mckinley.securecafe.com/residentservices/hillcrest8/userlogin.aspx',
        'hyde-park-flats': 'https://hyde-park-flats-mckinley.securecafe.com/residentservices/hyde-park-flats/userlogin.aspx',
        'indigo': 'https://indigo-winter-park-mckinley.securecafe.com/residentservices/indigo-winter-park/userlogin.aspx',
        'iris-flats': 'https://iris-flats-mckinley.securecafe.com/residentservices/iris-flats/userlogin.aspx',
        'ivy-flats': 'https://ivy-flats-mckinley.securecafe.com/residentservices/ivy-flats/userlogin.aspx',
        'manchester-west': 'https://manchester-west-mckinley.securecafe.com/residentservices/manchester-west/userlogin.aspx',
        'manchester-flats': 'https://manchester-flats-mckinley.securecafe.com/residentservices/manchester-flats0/userlogin.aspx',
        'meadowbrook-village': 'https://meadowbrook-village-mckinley.securecafe.com/residentservices/meadowbrook-village0/userlogin.aspx',
        'medical-center-court': 'https://medical-court-mckinley.securecafe.com/residentservices/medical-center-court0/userlogin.aspx',
        'monterey-lake': 'https://monterey-lake-mckinley.securecafe.com/residentservices/monterey-lake/userlogin.aspx',
        'olivia-flats': 'https://olivia-flats-mckinley.securecafe.com/residentservices/olivia-flats/userlogin.aspx',
        'mcdonald-mansion': 'https://mcdonald-mansion-mckinley.securecafe.com/residentservices/mcdonald-mansion/userlogin.aspx',
        'palio': 'https://palio-mckinley.securecafe.com/residentservices/palio/userlogin.aspx',
        'Palio': 'https://palio-mckinley.securecafe.com/residentservices/palio/userlogin.aspx',
        'park-place': 'https://park-place-mckinley.securecafe.com/residentservices/park-place22/userlogin.aspx',
        'parkland-flats': 'https://parkland-flats-mckinley.securecafe.com/residentservices/parkland-flats/userlogin.aspx',
        'piccadilly': 'https://piccadilly-flats-mckinley.securecafe.com/residentservices/piccadilly-flats/userlogin.aspx',
        'piccadilly-flats': 'https://piccadilly-flats-mckinley.securecafe.com/residentservices/piccadilly-flats/userlogin.aspx',
        'portofino': 'https://portofino-mckinley.securecafe.com/residentservices/portofino9/userlogin.aspx',
        'Portofino': 'https://portofino-mckinley.securecafe.com/residentservices/portofino9/userlogin.aspx',
        'positano': 'https://positano-mckinley.securecafe.com/residentservices/positano0/userlogin.aspx',
        'Positano': 'https://positano-mckinley.securecafe.com/residentservices/positano0/userlogin.aspx',
        'riva': 'https://riva-mckinley.securecafe.com/residentservices/riva1/userlogin.aspx',
        'Riva': 'https://riva-mckinley.securecafe.com/residentservices/riva1/userlogin.aspx',
        'roundtree': 'https://roundtree-roundtree-mckinley.securecafe.com/residentservices/roundtree/userlogin.aspx',
        'sapphire': 'https://sapphire-winter-park-mckinley.securecafe.com/residentservices/sapphire-winter-park/userlogin.aspx',
        'schoolhouse': 'https://schoolhouse-flats-mckinley.securecafe.com/residentservices/schoolhouse-flats/userlogin.aspx',
        'schoolhouse-flats': 'https://schoolhouse-flats-mckinley.securecafe.com/residentservices/schoolhouse-flats/userlogin.aspx',
        'schooner-cove': 'https://schooner-cove-mckinley.securecafe.com/residentservices/schooner-cove/userlogin.aspx',
        'serena': 'https://serena-winter-park-mckinley.securecafe.com/residentservices/serena-winter-park/userlogin.aspx',
        'spruce-knob': 'https://spruce-knob-mckinley.securecafe.com/residentservices/spruce-knob0/userlogin.aspx',
        'state-street-village': 'https://state-village-mckinley.securecafe.com/residentservices/state-street-village/userlogin.aspx',
        'studio-parc': 'https://studio-parc-mckinley.securecafe.com/residentservices/studio-parc/userlogin.aspx',
        'studioparc': 'https://studio-parc-mckinley.securecafe.com/residentservices/studio-parc/userlogin.aspx',
        'the-frederick': 'https://the-frederick-mckinley.securecafe.com/residentservices/the-frederick0/userlogin.aspx',
        'the-pines': 'https://the-pines-mckinley.securecafe.com/residentservices/the-pines4/userlogin.aspx',
        'the-villas': 'https://the-villas-mckinley.securecafe.com/residentservices/the-villas2/userlogin.aspx',
        'the-wesley': 'https://the-wesley-mckinley.securecafe.com/residentservices/the-wesley1/userlogin.aspx',
        'traver-courts': 'https://traver-courts-mckinley.securecafe.com/residentservices/traver-courts/userlogin.aspx',
        'traver-crossing': 'https://traver-crossing-mckinley.securecafe.com/residentservices/traver-crossing/userlogin.aspx',
        'traver-ridge': 'https://traver-ridge-mckinley.securecafe.com/residentservices/traver-ridge0/userlogin.aspx',
        'traver-heights': 'https://traver-heights-mckinley.securecafe.com/residentservices/traver-ridge0/userlogin.aspx',
        'westshore-flats-i': 'https://westshore-flats-i-mckinley.securecafe.com/residentservices/westshore-flats-i/userlogin.aspx',
        'westshore-flats-ii': 'https://westshore-flats-ii-mckinley.securecafe.com/residentservices/westshore-flats-ii/userlogin.aspx',
        'Westshore-flats': 'https://westshore-flats-i-mckinley.securecafe.com/residentservices/westshore-flats-i/userlogin.aspx',
        'westwood-suites': 'https://westwood-suites-mckinley.securecafe.com/residentservices/westwood-suites/userlogin.aspx',
        'willow-flats': 'https://willow-flats-mckinley.securecafe.com/residentservices/willow-flats/userlogin.aspx'
    };
}
